import { createFileRoute } from "@tanstack/react-router";
import Navbar from "@/components/Navbar";
import CityHeroShared from "@/components/CityHeroShared";
import CityMap from "@/components/CityMap";
import CityUseCases from "@/components/CityUseCases";
import MobileBookNowFab from "@/components/MobileBookNowFab";
import VehicleTypeIcons from "@/components/VehicleTypeIcons";
import FleetMeatSection, { ReviewsSection } from "@/components/FleetMeatSection";
import SprinterSpecsSection from "@/components/SprinterSpecsSection";
import SeoLongform from "@/components/SeoLongform";
import GeoAnswerBlock from "@/components/GeoAnswerBlock";
import { LOWELL_MA_REVIEWS } from "@/data/reviews/lowell_ma";
import { cityHeadMeta } from "@/data/citySeo";

export const Route = createFileRoute("/lowell-ma")({
  component: CityLanding,
  head: () => ({
    meta: [
      ...cityHeadMeta("lowell-ma"),
      { property: "og:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { property: "twitter:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sprinter-van-rentals.com/lowell-ma" }],
  }),
});

function CityLanding() {
  return (
    <main className="min-h-screen bg-white text-[#0F172A]">
      <Navbar />
      <MobileBookNowFab />
      <CityHeroShared
        citySlug="lowell-ma"
        cityLabel="Lowell"
        headline={"Lowell\nSprinter Van Rentals"}
        intro="Lowell Sprinter van rentals seating 12 and 15 passengers with full luggage space — delivered across Lowell and the surrounding Greater Boston area."
      />
<section id="fleet" className="max-w-[1440px] mx-auto px-6 pt-12 md:pt-16 pb-24 scroll-mt-24">
        <div className="mb-10">
          <p className="font-display font-bold text-xs uppercase tracking-[0.4em] mb-3 text-[#F97316]">The Lowell Sprinter Fleet</p>
          <h2 className="font-display font-black text-5xl md:text-6xl tracking-tight text-[#0F172A]">
            Lowell Sprinter van rentals, ready to book.
          </h2>
        </div>
        <VehicleTypeIcons accent="#F97316" citySlug={"lowell-ma" as never} />
      </section>

      <CityMap citySlug={"lowell-ma" as never} accent="#F97316" />
      <ReviewsSection city="lowell-ma" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Lowell" reviews={LOWELL_MA_REVIEWS} />
      <SprinterSpecsSection city="lowell-ma" accent="#F97316" />
      <FleetMeatSection city="lowell-ma" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Lowell" />
      <SeoLongform citySlug="lowell-ma" />
      <GeoAnswerBlock citySlug="lowell-ma" />
      <CityUseCases citySlug={"lowell-ma" as never} accent="#F97316" />
      <footer className="py-8 text-center border-t border-[#0F172A]/8">
        <p className="text-[#0F172A]/50 text-xs tracking-widest uppercase">&copy; 2026 Sprinter Van Rentals · Lowell</p>
      </footer>
    </main>
  );
}
